import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const CheckboxOff: FunctionalComponent<IIconProps> = ({ width = '20', height = '20', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20">
      <rect width="19" height="19" x=".5" y=".5" fill="#fff" stroke={fill} rx="3.5" />
    </svg>
  );
};

export default CheckboxOff;
